(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // A printer is required
    //

  function pxSitePrinterSettings(
    PrinterModel, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        isThisSiteMine: '=isThisSiteMine',
        printerInject: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/sitePrinterSettings/sitePrinterSettings.template.html',
      link: function(scope) {

        scope.printer = new PrinterModel(scope.printerInject);
        delete scope.printer.info.currentDate;
        scope.printerCopy = angular.copy(scope.printer);

        scope.savePrinter = function () {
          scope.printer.saveChanges(scope.printerCopy).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }

      }
    };
  }

  pxSitePrinterSettings.$inject = ['PrinterModel', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxSitePrinterSettings', pxSitePrinterSettings);

})();
